import React, {useEffect} from "react";
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {useTranslation} from "react-i18next";

//actions:
import {mediaItemsListActions} from "../../../redux/MediaItemsList/mediaItemsListRedux";

//logic:
import useTableDetails from "./useTableDetails";

//components:
import {
    VideoThumbnailEditor,
    ConfirmDelete,
    SuccessDelete,
    FailedDelete,
    FilterSearchBar,
    ReusableTable,
} from "../../../widgets";

const MediaItemsTableCard = () => {
    const {t} = useTranslation();
    const {
        allMediaItems,
        headRows,
        formatRow,
        emptyMessage,
        videoDetailsForThumbnailModal,
        showDeleteModal,
        showDeletedModal,
        showDeletedFailedModal,
        onDeleteVideoHandler,
        onDeleteImage,
        uploadVideoImg,
        filteredData,
        setFilteredData,
        openUploadImageModal,
        setOpenUploadImageModal,
        setShowDeleteModal,
        videoId,
        setVideoId,
        setShowDeletedModal,
        setShowDeletedFailedModal,
    } = useTableDetails();

    const {mediaItemsListError = {}, isLoadingMediaItemsList = true} = useSelector(state => state.mediaItemsList);

    const dispatch = useDispatch();
    const getAllMediaItems = () => dispatch(mediaItemsListActions.getAllMediaItems());

    useEffect(() => {
        getAllMediaItems();
    }, []);

    return (
        <div className="col-12 col-md-9">
            <div className="card card-custom gutter-b shadow">
                <div className="card-header flex-wrap pt-6 pb-0 border-bottom border-gray">
                    <div className="card-title">{t("ADMINPANEL.MENU.MEDIA_ITEMS")}</div>
                </div>
                <div className="card-body position-relative min-h-180px">
                    <FilterSearchBar
                        allItems={allMediaItems}
                        field="title"
                        setFiltered={setFilteredData}
                        placeholder={t("MODAL.VIDEOS_SELECTOR.SEARCHBAR.PLACEHOLDER")}
                    />
                    <ReusableTable
                        headRows={headRows}
                        allRows={allMediaItems}
                        filteredRows={filteredData}
                        formatRow={formatRow}
                        isLoading={isLoadingMediaItemsList}
                        errorMessage={mediaItemsListError}
                        emptyMessage={emptyMessage}
                        pagination
                    />

                    {/* DELETE VIDEO confirmations: */}
                    <ConfirmDelete
                        show={showDeleteModal}
                        onConfirm={onDeleteVideoHandler}
                        onCancel={() => {
                            setShowDeleteModal(false);
                            setVideoId("");
                        }}
                    />
                    <SuccessDelete
                        show={showDeletedModal}
                        onConfirm={() => {
                            setShowDeletedModal(false);
                        }}
                    />
                    <FailedDelete
                        show={showDeletedFailedModal}
                        onConfirm={() => {
                            setShowDeletedFailedModal(false);
                        }}
                    />

                    {/* upload image: */}
                    <VideoThumbnailEditor
                        id={`${videoId}`}
                        video={videoDetailsForThumbnailModal}
                        open={openUploadImageModal}
                        setOpen={setOpenUploadImageModal}
                        onUpload={uploadVideoImg}
                        onDeleteImage={onDeleteImage}
                    />
                </div>
            </div>
        </div>
    );
};

MediaItemsTableCard.propTypes = {
    editvideo: PropTypes.func,
    deletevideo: PropTypes.func,
    onUpload: PropTypes.func,
    notFoundMessage: PropTypes.string,
    isLoadingVideos: PropTypes.bool,
    errorMessage: PropTypes.string,
};

export default MediaItemsTableCard;
